import { z, ZodType } from 'zod'

/** Workaround for strict typedef of z.discriminatedUnion() */
export const getDiscriminatedUnionSchema = <T>(key: string, schemas: ZodType<T>[]): ZodType<T> => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return z.discriminatedUnion(key, schemas as any)
}
